import React from 'react';
import classnames from 'classnames';
import { makeStyles } from '@material-ui/core';
import { usePaymentOptionsAnimation } from 'payment/hooks';

const styles = makeStyles(({ palette }) => ({
  rectangle: {
    fill: palette.text.primary,
  },
  rectangleOne: {
    animation: '$rectangleSelected ease-in 500ms',
    animationFillMode: 'forwards',
  },
  rectangleTwo: {
    animation: '$rectangleSelected ease-in 500ms',
    animationFillMode: 'forwards',
    animationDelay: '500ms',
  },
  ticksBefore: {
    opacity: 0,
    stroke: palette.success.main,
  },
  tickOne: {
    animation: '$tickSelected ease-in 500ms',
    animationFillMode: 'forwards',
  },
  tickTwo: {
    animation: '$tickSelected ease-in 500ms',
    animationFillMode: 'forwards',
    animationDelay: '500ms',
  },
  '@keyframes rectangleSelected': {
    '0%': {
      fill: palette.text.primary,
    },
    '100%': {
      fill: palette.success.main,
    },
  },
  '@keyframes tickSelected': {
    '0%': {
      opacity: 0,
    },
    '100%': {
      opacity: 1,
    },
  },

  rectangleOneDeselected: {
    animation: '$rectangleDeselected ease-in 500ms',
    animationFillMode: 'forwards',
    animationDelay: '500ms',
    fill: palette.success.main,
  },
  rectangleTwoDeselected: {
    animation: '$rectangleDeselected ease-in 500ms',
    animationFillMode: 'forwards',
  },
  tickOneDeselected: {
    animation: '$tickDeselected ease-in 500ms',
    animationFillMode: 'forwards',
    opacity: 1,
    animationDelay: '500ms',
  },
  tickTwoDeselected: {
    animation: '$tickDeselected ease-in 500ms',
    animationFillMode: 'forwards',
  },
  '@keyframes rectangleDeselected': {
    '0%': {
      fill: palette.success.main,
    },
    '100%': {
      fill: palette.text.primary,
    },
  },
  '@keyframes tickDeselected': {
    '0%': {
      opacity: 1,
    },
    '100%': {
      opacity: 0,
    },
  },
}));

interface SelectItemsProps {
  isSelected: boolean;
}

const SelectItems = ({ isSelected }: SelectItemsProps) => {
  const classes = styles();
  const { playSelectedAnimation, playDeselectedAnimation } = usePaymentOptionsAnimation(isSelected);

  const boxOneAnimation = classnames([classes.rectangle], {
    [classes.rectangleOne]: playSelectedAnimation,
    [classes.rectangleOneDeselected]: playDeselectedAnimation,
  });

  const boxTwoAnimation = classnames([classes.rectangle], {
    [classes.rectangleTwo]: playSelectedAnimation,
    [classes.rectangleTwoDeselected]: playDeselectedAnimation,
  });

  const tickOneAnimation = classnames([classes.ticksBefore], {
    [classes.tickOne]: playSelectedAnimation,
    [classes.tickOneDeselected]: playDeselectedAnimation,
  });

  const tickTwoAnimation = classnames([classes.ticksBefore], {
    [classes.tickTwo]: playSelectedAnimation,
    [classes.tickTwoDeselected]: playDeselectedAnimation,
  });

  return (
    <svg
      width="106"
      height="106"
      viewBox="0 0 106 106"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        id="rectangleOne"
        className={boxOneAnimation}
        x="12"
        y="28"
        width="64"
        height="11"
        rx="2"
      />
      <rect
        id="rectangleTwo"
        className={boxTwoAnimation}
        x="12"
        y="47"
        width="64"
        height="11"
        rx="2"
      />
      <rect
        id="rectangleThree"
        className={classes.rectangle}
        x="12"
        y="66"
        width="64"
        height="11"
        rx="2"
      />
      <rect
        id="checkBoxOne"
        className={classes.rectangle}
        x="84"
        y="28"
        width="11"
        height="11"
        rx="2"
        fillOpacity="0.2"
      />
      <rect
        id="checkBoxTwo"
        className={classes.rectangle}
        x="84"
        y="47"
        width="11"
        height="11"
        rx="2"
        fillOpacity="0.2"
      />
      <rect
        id="thirdCheckbox"
        className={classes.rectangle}
        x="84"
        y="66"
        width="11"
        height="11"
        rx="2"
        fillOpacity="0.2"
      />

      <path
        id="tickOne"
        d="M86 32.5L89.5 36L98.5 27"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className={tickOneAnimation}
      />
      <path
        id="tickTwo"
        d="M86 51.5L89.5 55L98.5 46"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className={tickTwoAnimation}
      />
    </svg>
  );
};

export default SelectItems;
